<template>
  <b-modal
    id="MailPreviewModal"
    title-html=""
    body-class="modalBox"
    content-class="p-5"
    size="xl"
    ok-title="閉じる"
    ok-variant="secondary"
    :hide-header-close="true"
    :centered="true"
    :ok-only="true"
  >
    <div class="">
      <p class="title mb-0">メール送信プレビュー</p>
      <hr class="title">
    </div>

    <div class="mb-3">
      <label class="bold mb-1">添付ファイル</label>
      <div v-if="fileList.length === 0">ファイルなし</div>
      <p
        v-for="(file, index) in fileList" :key="index"
        class="mb-0">{{ file.name }}</p>
    </div>

    <div class="mb-3">
      <label class="bold mb-1">タイトル</label>
      <div class="previewSubject">{{ title }}</div>
    </div>

    <div>
      <label class="bold mb-1">本文</label>
      <div class="previewBody">{{ previewMessage }}</div>
    </div>
  </b-modal>

</template>
<script>
export default {
  name: 'MailPreviewModal',
  props: {
    title: {
      default: '',
    },
    message: {
      default: '',
    },
    fileList: {
      default: () => [],
    },
    targetUser: {
      default: null,
    },
  },
  computed: {
    // 送信先1件目のデータで本文のプレースホルダを置換する。
    // backend AppMail::_getMessage と同じ3置換・全出現置換・未設定は空白。
    previewMessage() {
      const user = this.targetUser;
      if (!user) {
        return this.message;
      }
      let { message } = this;
      message = message.split('{%氏名%}').join(user.name != null ? user.name : '');
      message = message.split('{%所属機関%}').join(user.institution_name != null ? user.institution_name : '');
      message = message.split('{%金額%}').join(user.granted_money != null ? user.granted_money : '');
      return message;
    },
  },
};
</script>

<style>
  .modal-header {
    display: none !important;
  }
  .modal-footer {
    border-width: 0 !important;
  }
</style>

<style scoped>
  .previewSubject {
    word-break: break-all;
  }
  /* 本文の改行・連続スペースを保持して表示 */
  .previewBody {
    white-space: pre-wrap;
    word-break: break-all;
  }
</style>
